import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Context/TokenContext';

const ProtectedRoute = ({ children }) => {
    const { session, loading } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!loading && !session) {
            sessionStorage.setItem('postLoginRedirect', location.pathname);
            navigate('/login');
        }
    }, [loading, session, navigate, location.pathname]);

    if (loading) {
        return <div className="loadingStyle">Loading...</div>;
    }

    if (!session) {
        return <div className="loadingStyle">Redirecting to login...</div>;
    }

    return children;
};

export default ProtectedRoute;
